import { apiClient } from './client';
export const audienceApi = {
    search: async (clientCompanyId, workspaceId, filters) => {
        const params = new URLSearchParams();
        if (filters?.CampaignId)
            params.append('campaignId', filters.CampaignId);
        if (filters?.CampaignStatuses)
            filters.CampaignStatuses.forEach(s => params.append('campaignStatus', s));
        if (filters?.CampaignName)
            params.append('campaignName', filters.CampaignName);
        if (filters?.CreatedDateFrom)
            params.append('createdDateFrom', filters.CreatedDateFrom);
        if (filters?.CreatedDateTo)
            params.append('createdDateTo', filters.CreatedDateTo);
        const qs = params.toString();
        return apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/Audiences${qs ? '?' + qs : ''}`);
    },
    // Create a new audience with file upload
    create: async (clientCompanyId, workspaceId, data, file) => {
        const formData = new FormData();
        formData.append('data', JSON.stringify(data));
        formData.append('file', file);
        return apiClient.post(`/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/Audiences`, formData);
    },
    // Get analytics for a specific audience
    getAnalytics: async (clientCompanyId, workspaceId, campaignId, audienceId, signal) => {
        return apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/Campaigns/${campaignId}/Audiences/${audienceId}/analytics`, { signal });
    },
    // List audiences by campaign
    listByCampaign: (clientCompanyId, workspaceId, campaignId) => apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/Campaigns/${campaignId}/Audiences`),
    // Phone enrichment for file import rows
    enrichPhone: (clientCompanyId, workspaceId, campaignId, fileImportRowId, signal) => {
        const url = `/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/Campaigns/${campaignId}/Audiences/${fileImportRowId}/EnrichPhone`;
        return apiClient.post(url, {}, { signal });
    },
    syncPhone: (clientCompanyId, workspaceId, campaignId, fileImportRowId, signal) => {
        const url = `/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/Campaigns/${campaignId}/Audiences/${fileImportRowId}/SyncPhone`;
        return apiClient.post(url, {}, { signal });
    },
    // Re-enrich file import row (full contact data enrichment)
    reEnrich: (clientCompanyId, workspaceId, campaignId, fileImportRowId, signal) => {
        const url = `/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/Campaigns/${campaignId}/Audiences/${fileImportRowId}/re-enrich`;
        return apiClient.post(url, {}, { signal });
    }
};
export default audienceApi;
